import React from "react";
import { connect } from "react-redux";
import { translate } from "../../../base/i18n/functions";
import AbstractPageReloadOverlay, { abstractMapStateToProps } from "./AbstractPageReloadOverlay";
import NoConnectionPopup from "./NoConnectionPopup/NoConnectionPopup";
import ReloadPopup from "./ReloadPopup";
class PageReloadOverlay extends AbstractPageReloadOverlay {
    render() {
        const { isNetworkFailure } = this.props;
        if (!isNetworkFailure) {
            return React.createElement(ReloadPopup, null);
        }
        return React.createElement(NoConnectionPopup, { getLocalization: this.props.t });
    }
}
export default translate(connect(abstractMapStateToProps)(PageReloadOverlay));
